import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

/**
 * @param {object} payload.cartData - The cart data after gift is removed
 */
export const onTrackRemoveVariationGift = async (payload) => {
  const { cartData } = payload;

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemRemoved.name, cartData);
};
